import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";

export default function Cancel() {
  return (
    <>
      <Header minimal />
      <main className="max-w-2xl mx-auto px-6 pt-24 text-center">
        <h1 className="font-serif text-4xl font-light text-stone-900">Payment cancelled</h1>
        <p className="mt-4 text-stone-600">Your appointment isn't confirmed. You can try the payment again from your cart.</p>
        <Link to="/cart" data-testid="back-to-cart" className="mt-8 inline-block border border-stone-900 px-6 py-3 mono-label hover:bg-stone-900 hover:text-white">Back to Cart</Link>
      </main>
    </>
  );
}
